import { createSlice } from '@reduxjs/toolkit';

const initialState = {

    callAssistant: {
        loading: true,
        error: null,
        quotaStatus: null,
    },
    chatAssistant: {
        loading: true,
        error: null,
        quotaStatus: null,
    },
};


export const assistantQuotaSlice = createSlice({
    name: 'assistantQuota',
    initialState,
    reducers: {

        setCallAssistantQuota: (state, action) => {
            state.callAssistant.loading = false;
            state.callAssistant.error = null;
            state.callAssistant.quotaStatus = action.payload;
        },

        setChatAssistantQuota: (state, action) => {
            state.chatAssistant.loading = false;
            state.chatAssistant.error = null;
            state.chatAssistant.quotaStatus = action.payload;
        },


        resetCallAssistantQuota: (state) => {
            state.callAssistant = initialState.callAssistant;
        },

        resetChatAssistantQuota: (state) => {
            state.chatAssistant = initialState.chatAssistant;
        },

        resetAssistantQuota: () => initialState,
    },
});

export const {
    setCallAssistantQuota,
    setChatAssistantQuota,
    resetCallAssistantQuota,
    resetChatAssistantQuota,
    resetAssistantQuota

} = assistantQuotaSlice.actions;

export const selectCallAssistantQuota = (state) => state.assistantQuota.callAssistant;
export const selectChatAssistantQuota = (state) => state.assistantQuota.chatAssistant;

export default assistantQuotaSlice.reducer;